/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { Modal, Form, Input, message, DatePicker } from 'antd';
import _cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import styles from './academicYearModal.less';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const { confirm } = Modal;

// 时间戳转Date格式
const getDateFormat = function(time) {
  if (!time) return null;
  return moment(new Date(time), 'YYYY-MM-DD');
};
export default class AcademicYearModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        schoolYearId: null,
        schoolYearName: '',
        schoolTerms: [], // 学期列表
      },
      chineseNums: ['一', '二', '三', '四', '五', '六', '七', '八', '九'], // 创建新学期时用来匹配学期的名称
    };

    this.onOk = this.onOk.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.renderForm = this.renderForm.bind(this);
    this.schoolYearNameChange = this.schoolYearNameChange.bind(this);
    this.initFormData = this.initFormData.bind(this);

    this.initFormData(props);
  }

  //  设置数据
  componentWillReceiveProps(nextProps) {
    this.initFormData(nextProps);
  }

  // 表单验证
  onOk() {
    const { schoolYearName, schoolTerms } = this.state.formData;

    if (
      schoolYearName === undefined ||
      schoolYearName.trim() === '' ||
      schoolYearName.trim().length === 0
    ) {
      return message.error('学年名称不能为空！');
    }

    if (schoolYearName.trim().length > 50) {
      return message.error('学年名称长度不能超过50！');
    }

    // 学期数据判断
    if (schoolTerms === undefined || schoolTerms.length < 2) {
      return message.error('学期信息有误，请重试！');
    }

    const isHasNull = schoolTerms.some(term => {
      if (
        term.endDate === undefined ||
        term.endDate === null ||
        term.startDate === undefined ||
        term.startDate === null ||
        term.startDate === term.endDate
      ) {
        message.error(`${term.termName}起止时间有误！`);
        return true;
      }
      return false;
    });
    if (isHasNull) {
      return '';
    }
    if (this.props.onModelOk) {
      this.props.onModelOk(this.state.formData);
    }
  }

  onCancel() {
    if (this.props.onModelCancel) {
      this.props.onModelCancel(false);
    }
  }

  // 设置新增时第一学期和第二学期默认数据
  setSchoolTermsDefaultDate(year) {
    this.setState({
      formData: {
        schoolYearId: null,
        schoolYearName: `${year}-${year + 1}学年`,
        schoolTerms: [
          {
            schoolTermId: null,
            termName: `第一学期`,
            startDate: new Date(`${year}-09-01`).getTime(),
            endDate: new Date(`${year + 1}-02-01`).getTime(),
            sortNum: null,
          },
          {
            schoolTermId: null,
            termName: `第二学期`,
            startDate: new Date(`${year + 1}-03-01`).getTime(),
            endDate: new Date(`${year + 1}-07-01`).getTime(),
            sortNum: null,
          },
        ],
      },
    });
  }
  /**
   *  第1学期起止时间：2018年7月之前默认为“2017-09-01~2018-02-01”，2019年7月之后默认为“2018-09-01~2019-02-01”
   *  第2学期起止时间：2018年7月之前默认为“2017-03-01~2018-07-01”，2019年7月之后默认为“2018-03-01~2019-07-01”
   * */
  initFormData(props) {
    if (props.info && props.info.length !== 0) {
      this.setState({
        formData: props.info,
      });
    } else {
      const date = new Date();
      const year = date.getFullYear();

      if (date.getMonth() + 1 <= 7) {
        this.setSchoolTermsDefaultDate(year - 1);
      } else {
        this.setSchoolTermsDefaultDate(year);
      }
    }
  }

  // 学年名称修改
  schoolYearNameChange(e) {
    const name = e.target.value;
    if (name !== undefined && name.trim().length > 50) {
      message.error('学年名称长度不得超过50个字符');
    } else if (name !== undefined) {
      this.setState({
        formData: Object.assign({}, this.state.formData, {
          schoolYearName: name,
        }),
      });
    }
  }

  // 学期日期修改
  schoolTermChange(termName, newDateInterval) {
    if (!termName || !termName.length) {
      return;
    }

    if (!newDateInterval) {
      message.error('学期日期区间不能为空');
      return !1;
    }

    if (newDateInterval && newDateInterval.length && newDateInterval[0]._d.getTime() === newDateInterval[1]._d.getTime()) {
      message.error('学期起止时间不能相同');
      return !1;
    }

    // 对象数据赋值
    const newTermDatas = this.state.formData.schoolTerms.map(data => {
      if (data.termName && data.termName === termName) {
        const newData = _cloneDeep(data);
        newData.startDate = newDateInterval[0]._d.getTime();
        newData.endDate = newDateInterval[1]._d.getTime();
        return newData;
      }
      return data;
    });

    if (newTermDatas && newTermDatas.length > 0) {
      this.setState({
        formData: Object.assign({}, this.state.formData, { schoolTerms: newTermDatas }),
      });
    }
  }

  // 删除新增的数组
  delSchoolTerm(termName) {
    const { formData, chineseNums } = this.state;
    const that = this;

    confirm({
      title: '确定要删除该学期吗？',
      content: '删除有风险，请仔细确认后执行删除操作！',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        if (!termName || !termName.length) {
          return '';
        }

        // 组合新的学期列表，删掉的学期后面的学期序列自动向前减一
        const newTermDatas = [];
        let index = 0; // 被删除的学期下标
        formData.schoolTerms.forEach((term, i) => {
          if (term.termName && term.termName === termName) {
            index = i;
            return;
          }
          if (index >= 2) {
            newTermDatas.push(
              Object.assign({}, term, {
                termName: `第${chineseNums[i - 1]}学期`,
              })
            );
          } else {
            newTermDatas.push(term);
          }
        });

        that.setState({
          formData: Object.assign({}, formData, { schoolTerms: newTermDatas }),
        });
      },
      onCancel() {},
    });
  }

  // 新增学期
  addSchoolTerm() {
    const { schoolTerms } = this.state.formData;
    const newTermDatas = _cloneDeep(schoolTerms);
    const len = schoolTerms.length;
    if (len > 9) {
      return message.error('学期创建已经达到上线!');
    }

    newTermDatas.push({
      schoolTermId: null,
      termName: `第${this.state.chineseNums[len]}学期`,
      startDate: null,
      endDate: null,
      sortNum: null,
    });

    this.setState({
      formData: Object.assign({}, this.state.formData, { schoolTerms: newTermDatas }),
    });
  }

  // 渲染日期组件
  renderForm(schoolTerms) {
    return schoolTerms.map((term, index) => {
      const { schoolTermId, termName, startDate, endDate } = term;

      return (
        <FormItem
          id={schoolTermId}
          label={termName}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 14 }}
        >
          <a
            className={index > 1 ? 'show' : 'hidden'}
            onClick={this.delSchoolTerm.bind(this, termName)}
          >
            删除
          </a>
          <div>
            <span className="label">起止时间</span>

            <RangePicker
              style={{ width: 184 }}
              value={[getDateFormat(startDate), getDateFormat(endDate)]}
              required
              onChange={this.schoolTermChange.bind(this, termName)}
            />
          </div>
        </FormItem>
      );
    });
  }

  render() {
    const { schoolYearId, schoolTerms, schoolYearName } = this.state.formData;

    if (!schoolTerms || schoolTerms.length === 0) {
      return <div />;
    }

    return (
      <Modal
        title="添加新学年"
        wrapClassName="vertical-center-modal"
        visible={this.props.visible}
        onOk={this.onOk}
        onCancel={this.onCancel}
        className={styles.root}
      >
        <Form horizontal>
          <FormItem
            id={schoolYearId}
            label="学年名称"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 14 }}
          >
            <Input
              value={schoolYearName}
              placeholder="请输入学年名称"
              onChange={this.schoolYearNameChange}
            />
          </FormItem>

          {schoolTerms && schoolTerms.length !== 0 && this.renderForm(schoolTerms)}
          {schoolTerms.length < 9 && (
            <FormItem
              label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 14 }}
            >
              <a className="addBtn" onClick={this.addSchoolTerm.bind(this)}>
                + 添加新学期
              </a>
            </FormItem>
          )}
        </Form>
      </Modal>
    );
  }
}
